import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router-dom";
import styles from "../../styles/common/navbar.module.css";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import NavBarGovernance from "./NavBarGovernance";
import { Download } from "@mui/icons-material";

interface Props {
  childern?: JSX.Element;
  lightTheme?: boolean;
}

export const handleDownload = (
  type: "WolframGovernanceData" | "CatalystProposalData"
) => {
  const a = document.createElement("a");

  if (type === "WolframGovernanceData") {
    a.href = window.SQL_DUMP_URL_WOLFRAM_GOVERNANCE as any;
    a.download = "Cardano_SQL_DUMP.zip";
  } else {
    a.href = window.SQL_DUMP_URL_CATALYST_PROPOSAL as any;
    a.download = "Cardano_Catalyst_Proposal_SQL_DUMP.zip";
  }
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export default function Navbar(props: Props) {
  const location = useLocation();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const closeModalHandler = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Grid
      container
      className={styles.mobileModalGridContainer}
      direction="column"
    >
      <Grid item>
        <IconButton onClick={closeModalHandler} className={styles.button}>
          <CloseIcon className={styles.closeIcon} />
        </IconButton>
      </Grid>

      <Grid item>
        <Link to={`/`}>
          <Button
            className={`${styles.buttonContainer} ${
              location.pathname === "/" && styles.buttonContainerCurrent
            }`}
          >
            Home
          </Button>
        </Link>
      </Grid>
      <Grid item>
        <Link to={`/funds`}>
          <Button
            className={`${styles.buttonContainer} ${
              location.pathname === "/funds" && styles.buttonContainerCurrent
            }`}
          >
            Funds
          </Button>
        </Link>
      </Grid>

      <Grid item>
        <Link to={`/challenges`}>
          <Button
            className={`${styles.buttonContainer} ${
              location.pathname === "/challenges" &&
              styles.buttonContainerCurrent
            }`}
          >
            Challenges
          </Button>
        </Link>
      </Grid>

      <Grid item>
        <Link to={`/proposals`}>
          <Button
            className={`${styles.buttonContainer} ${
              location.pathname === "/proposals" &&
              styles.buttonContainerCurrent
            }`}
          >
            Proposals
          </Button>
        </Link>
      </Grid>

      <Grid item>
        <Link to={`/proposers`}>
          <Button
            className={`${styles.buttonContainer} ${
              location.pathname === "/proposers" &&
              styles.buttonContainerCurrent
            }`}
          >
            Proposers
          </Button>
        </Link>
      </Grid>
      <Grid item>
        <Link to={`/analytics`}>
          <Button
            className={`${styles.buttonContainer} ${
              location.pathname === "/analytics" &&
              styles.buttonContainerCurrent
            }`}
          >
            Analytics
          </Button>
        </Link>
      </Grid>
      <Grid item>
        <Button
          className={`${styles.buttonContainer}`}
          onClick={() => handleDownload("WolframGovernanceData")}
        >
          <Download /> Governance Data
        </Button>
      </Grid>
      <Grid item>
        <Button
          className={`${styles.buttonContainer}`}
          onClick={() => handleDownload("CatalystProposalData")}
        >
          <Download /> Catalyst Proposal Data
        </Button>
      </Grid>
    </Grid>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        component="nav"
        style={{
          backgroundColor: props.lightTheme
            ? "white"
            : "var(--theme-navbar-color) !important",
        }}
        elevation={props.lightTheme ? 0 : 4}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 0, display: { sm: "none" } }}
          >
            <MenuIcon sx={{ color: props.lightTheme ? "black" : "inherit" }} />
          </IconButton>
          <Link to={`/`}>
            <span className={styles.logoNameContainer}>
              <img
                className={styles.logo}
                src={`${process.env.PUBLIC_URL}/img/cardano-logo.png`}
                alt="logo"
                height={40}
                width={40}
              />
              {!props.lightTheme && (
                <Typography className={styles.appName}>Cardano</Typography>
              )}
            </span>
          </Link>
          <Box
            sx={{ display: { xs: "none", sm: "block" } }}
            className={styles.navbarRightButtonGroup}
          >
            <Link to={`/`}>
              <Button
                className={`${
                  props.lightTheme
                    ? styles.buttonContainerLight
                    : styles.buttonContainer
                } ${
                  location.pathname === "/" && styles.buttonContainerCurrent
                }`}
              >
                Home
              </Button>
            </Link>
            <NavBarGovernance
              buttonType="Governance"
              lightTheme={props.lightTheme}
            />
            {/* <NavBarGovernance buttonType="About"/> */}

            <NavBarGovernance buttonType="UTX" lightTheme={props.lightTheme} />
            <Link to={`/apiDocuments`}>
              <Button
                className={`${
                  props.lightTheme
                    ? styles.buttonContainerLight
                    : styles.buttonContainer
                } ${
                  location.pathname === "/apiDocuments" &&
                  styles.buttonContainerCurrent
                }`}
              >
                APIs
              </Button>
            </Link>
            <NavBarGovernance
              buttonType="DownloadGovernanceData"
              lightTheme={props.lightTheme}
            />
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { width: "80%" },
          }}
          transitionDuration={100}
        >
          {drawer}
        </Drawer>
      </Box>
      <Box component="main">
        <Toolbar />
        {props.childern}
      </Box>
    </Box>
  );
}
